import { Foundation } from './foundation.core';

import { Tabs } from '../../foundation.tabs';
Foundation.plugin(Tabs, 'Tabs');

export { Foundation, Tabs };



// WEBPACK FOOTER //
// ../node_modules/foundation-sites/js/entries/plugins/foundation.tabs.js